export enum EColorScheme {
  Light = "light",
  Dark = "dark",
}
